import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative w-full" }

import { ref, watch } from 'vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'inputCustom',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const emit = __emit;

  const localValue = ref(props.modelValue);

  watch(
    () => props.modelValue,
    (newValue) => {
      localValue.value = newValue;
    }
  );

  function updateValue(value: string) {
    localValue.value = value;
    emit('update:modelValue', value);
  }

  function clearInput() {
    updateValue('');
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (updateValue($event.target.value))),
      type: "text",
      placeholder: "Enter URL",
      class: "w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    }, null, 544), [
      [_vModelText, localValue.value]
    ]),
    (localValue.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: clearInput,
          class: "absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-5 w-5",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})